// JoinUs.js
import React from 'react';
import { Link } from 'react-router-dom';

const JoinUs = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">By believing in the vision of Deliveranz, you are ahead of the times.</h1><br/>
      <p className="card-text">If you believe in providing services for the small business owners,<br/>you can mail us your credentials at:<br/><br/><b>info@deliveranz.com.sg</b><br/><br/>for a discussion.<br/>Remember, business automation goes hand-in-hand with the edge cases you address!</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default JoinUs;
